export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更預告_kr-20c642d029c097bf2f1a5daa35a3c60c.webp";